<script lang='ts'>
  let message = 'Hello World';
  let streams = [];

  console.log(window.opener)
  window.opener.postMessage('getStreams')

  window.onmessage = (e) => {
    console.log(e.data)
    if (e.data.type === 'streams') {
      streams = e.data.streams
    }
  }

  const muteToggle = (stream) => {
    window.opener.postMessage({
      type: stream.muted ? 'unmute' : 'mute',
      stream: stream.name
    })
  }

  const fullscreenToggle = (key, stream) => {
    window.opener.postMessage({
      type: 'fullscreen',
      fullscreen: stream.fullscreen ? null : stream.name,
      stream: stream.name
    })
  }
</script>

<main>
  <div class='streams'>
    {#each streams as stream, key (`${stream.name}_${key}`)}
      <div class='stream'>
        {stream.name}
        <div class='stream-buttons'>
          <button class='stream-button' on:click={() => muteToggle(stream)}>
            {#if stream.muted}
              Unmute
            {:else}
              Mute
            {/if}
          </button>
          <button class='stream-button' on:click={() => fullscreenToggle(key, stream)}>
            {#if stream.fullscreen}
              Exit Fullscreen
            {:else}
              Fullscreen
            {/if}
          </button>
        </div>
      </div>
    {/each}
  </div>
</main>

<style>
  main {
    padding: 16px;
  }

  .streams {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }

  .stream {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: rgb(0 0 0/.5);
    border-radius: 4px;
  }

  .stream-buttons {
    display: flex;
    column-gap: 8px;
  }

  .stream-button {
    display: flex;
    margin: 0;
  }
</style>
